import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'
import CerticationStore from '../Certification/CertificationStore'
import './certificationSidebar.scss'
import Standard from '../Certification/Standard'
import Accordion from '../Report/components/Accordion'
import SelfCertify from '../Certification/SelfCertify'
import Button from '../../UniformComponents/Button'
import Typography from '../../UniformComponents/Typography'

@observer
class CertificationSidebar extends Component {
    constructor(props) {
        super(props)
        this.defaultTopOffset = 114
        const defaultState = window.localStorage.getItem(props.store.survey.id)
        this.state = {
            hidden: defaultState,
            topOffset: this.defaultTopOffset,
        }
        window.localStorage.setItem(props.store.survey.id, true)
        this.certificationStore = new CerticationStore(this.props.store)
    }

    componentDidMount() {
        this.certificationStore.getCertification()
        window.addEventListener('scroll', this.handleScroll)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    handleScroll = () => {
        const { scrollY } = window
        this.setState({ topOffset: Math.max(this.defaultTopOffset - scrollY, 54) })
    }

    certificateIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="49.477" height="65.204" viewBox="0 0 49.477 65.204">
            <path id="workspace_premium_FILL0_wght200_GRAD0_opsz48" d="M27.317,42.313l2.827-9.189-7.422-5.3h9.1l2.916-9.454,2.827,9.454h9.189l-7.333,5.3,2.739,9.189-7.422-5.655ZM17.245,71.2V48.144a23.278,23.278,0,0,1-5.434-8.04A24.884,24.884,0,0,1,10,30.739a23.9,23.9,0,0,1,7.157-17.582A23.9,23.9,0,0,1,34.739,6a23.9,23.9,0,0,1,17.582,7.157,23.9,23.9,0,0,1,7.157,17.582A24.884,24.884,0,0,1,57.666,40.1a23.279,23.279,0,0,1-5.434,8.04V71.2L34.739,65.991ZM34.739,52.738a21.3,21.3,0,0,0,15.594-6.361,21.182,21.182,0,0,0,6.406-15.638,21.3,21.3,0,0,0-6.361-15.594A21.182,21.182,0,0,0,34.739,8.739,21.3,21.3,0,0,0,19.144,15.1a21.182,21.182,0,0,0-6.406,15.638A21.3,21.3,0,0,0,19.1,46.333,21.182,21.182,0,0,0,34.739,52.738ZM19.9,67.67l14.843-4.594L49.582,67.67V50.441a22.875,22.875,0,0,1-7.068,3.8,25.054,25.054,0,0,1-15.55,0,22.875,22.875,0,0,1-7.068-3.8ZM34.739,59.011Z" transform="translate(-10 -6)" fill="#4c5f8a" />
        </svg>
    )

    surveyStandardsMet = () => {
        const { automatic, isLoading } = this.certificationStore

        return !isLoading && automatic.filter(({ passed }) => !passed).length === 0
    }

    renderWarning = () => {
        const surveyStandardsMet = this.surveyStandardsMet()

        if (!surveyStandardsMet) {
            return (
                <div className="certificationWarning warning">
                    <i className="fa-sharp fa-light fa-triangle-exclamation" />
                    <Typography type="p">{i18n.t('certificationSidebar.warning')}</Typography>
                </div>
            )
        }

        return null
    }

    renderBody = () => {
        const { history, store } = this.props
        const { survey } = store
        const { certificationStore } = this
        const { certificationStatus, standardIcon } = certificationStore
        const surveyStandardsMet = this.surveyStandardsMet()

        if (!surveyStandardsMet) {
            return (
                <div className="panel">
                    <h4>{i18n.t('certificationSidebar.mainTitle')}</h4>
                    <p>{i18n.t('certificationSidebar.mainSubtitle')}</p>
                    <div className="panelBody">
                        {certificationStore.automatic.map((standard, i) => (
                            <Standard
                                key={standard.type}
                                certificationStore={certificationStore}
                                standard={standard}
                                icon={standardIcon(standard)}
                                index={i}
                            />
                        ))}
                    </div>
                </div>

            )
        }

        return (
            <div>
                <div className="panel">
                    <Accordion
                        title={(
                            <div className="accordianTitle">
                                <div className="mainTitle">
                                    <i className="fa-regular fa-circle-check" />
                                    <Typography type="h3">{i18n.t('certificationSidebar.mainTitle')}</Typography>
                                </div>
                                <Typography type="p">{i18n.t('certificationSidebar.mainSubtitle')}</Typography>
                            </div>
                        )}
                        cssClass="standardsAccordion"
                        openIcon="fa-solid fa-chevron-down"
                        closeIcon="fa-solid fa-chevron-up"
                    >
                        <div className="panelBody">
                            {certificationStore.automatic.map((standard, i) => (
                                <Standard
                                    key={standard.type}
                                    certificationStore={certificationStore}
                                    standard={standard}
                                    icon={standardIcon(standard)}
                                    index={i}
                                />
                            ))}
                            {surveyStandardsMet ? (
                                <div className="certificationWarning success">
                                    <i className="fa-regular fa-circle-check" />
                                    <Typography type="p">{i18n.t('certificationSidebar.passed')}</Typography>
                                </div>
                            ) : null}
                        </div>
                    </Accordion>
                </div>
                <div className="panelBody selfAssessment">
                    <Typography type="h3">{i18n.t('certificationSidebar.selfCertifyTitle')}</Typography>
                    <Typography type="p">{i18n.t('certificationSidebar.selfCertifySubtitle')}</Typography>
                    {
                        certificationStore.selfAssessed.map((selfSelectQuestion, i) => (
                            <SelfCertify
                                key={selfSelectQuestion.id}
                                certificationStore={certificationStore}
                                selfSelectQuestion={selfSelectQuestion}
                                index={i}
                            />
                        ))
                    }
                    <div className="disclaimer">
                        <Typography type="tiny">{i18n.t('certificationSidebar.selfCertifyDisclaimer')}</Typography>
                    </div>
                    <div className="certificationConfirmation">
                        {certificationStatus === 'uncertified'
                            ? (
                                <Button
                                    cssClass="regular"
                                    variant="secondary"
                                    label={i18n.t('gen_confirm_popup_title')}
                                    onClick={certificationStore.updateSurveyCertification()}
                                />
                            )
                            : (
                                <Button
                                    cssClass="regular"
                                    variant="secondary"
                                    label={i18n.t('certificationSidebar.viewCertificate')}
                                    onClick={() => history.push(`/survey/${survey.id}/certification`)}
                                />
                            )}
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { hidden, topOffset } = this.state
        const { scrollY } = window

        return (
            <div className="certificationSidebar" style={{ top: `${topOffset}px`, height: `calc(100vh - ${topOffset}px)` }}>
                <div
                    className="certificationTab"
                    onClick={() => this.setState({ hidden: !hidden })}
                    style={{ marginTop: `calc(50vh + ${scrollY > this.defaultTopOffset - 54 ? this.defaultTopOffset - 54 : scrollY}px - 95px)` }}
                >
                    <i className="fa-regular fa-badge-check" />
                    {i18n.t('certificationSidebar.title')}
                    {' '}
                    <span>NEW</span>
                </div>
                <div className={`content ${hidden ? 'closed' : ''}`}>
                    <div className="sidebarHeader">
                        <div className="titles">
                            <Typography type="h2">{i18n.t('certificationSidebar.title')}</Typography>
                            <Typography type="p">{i18n.t('certificationSidebar.subtitle')}</Typography>
                        </div>
                        <img src={`${process.env.CDN_URL}/images/certificationBadge.png`} alt="certification badge" />
                    </div>
                    {this.renderWarning()}
                    {this.renderBody()}
                </div>
            </div>
        )
    }
}

export default CertificationSidebar
